import ThemeChanger from "../components/ThemeChanger";
import Intro from "../components/Intro";
import LSLayout from "../components/LSLayout";
import RSLayout from "../components/RSLayout";
import ImportResumeJSON from "../components/ImportResumeJSON";
import DownloadTemplateJSON from "../components/DownloadTemplateJSON";
import DownloadResumeJSON from "../components/DownloadResumeJSON";
import { useTheme } from "../hooks/useTheme";
import PreviewResume from "../components/PreviewResume";
import { useSelector } from "react-redux";
import { State } from "../props/State.props";
import DownloadPDF from "../components/DownloadPDF";
import { useEffect, useState } from "react";
import supabase from "../configs/supabase/client";
import { BiLogOutCircle, BiLoaderAlt } from "react-icons/bi";
import { RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import HowToUse from "../components/HowToUse";

function App() {
  const [theme] = useTheme();
  const getTheme: string = useSelector((state: State) => state.getTheme);
  const [user, setUser] = useState("");
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [use, setUse] = useState(false);

  useEffect(() => {
    (async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (user) setUser(user.user_metadata.username);
      else navigate("/login");
    })();
  }, []);

  const Instruction = () => {
    return (
      <div
        className={`w-full h-full fixed z-[9999] top-0 left-0 flex justify-center items-center ${theme.bg()} ${theme.fg()}`}
      >
        <div
          className={`fixed flex justify-center items-center z-[9999] top-5 right-5 w-10 h-10 ${theme.secondary_bg()} ${theme.secondary_fg()} ${theme.border()} rounded-full text-sm font-bold cursor-pointer border`}
          onClick={() => {
            setUse(!use);
          }}
          title="Close Preview"
        >
          <AiOutlineClose />
        </div>
        <video
          className="w-[90%] H-[90%] rounded-xl"
          controls
          controlsList="nodownload"
        >
          <source src="demo.mp4" type="video/mp4" />
        </video>
      </div>
    );
  };

  return user !== "" ? (
    <div className="w-screen h-screen overflow-y-auto px-5 py-5 bg-gray-200 flex justify-between items-start flex-wrap lg:flex-nowrap gap-4">
      <div className="xs:hidden lg:block w-full lg:max-w-[20rem] h-[30%] lg:h-full bg-dark-bg p-5 rounded-2xl overflow-y-auto">
        <div className={`text-md font-bold text-light-bg mb-5`}>
          Howdy {user},
        </div>
        {use && <Instruction />}
        <HowToUse use={use} setUse={setUse} />
        <DownloadTemplateJSON />
        <ImportResumeJSON />
        <ThemeChanger />
        <PreviewResume theme={getTheme} />
        <DownloadPDF />
        <DownloadResumeJSON />
      </div>
      <div
        className={`${theme.bg()} ${theme.fg()} w-full h-full lg:h-full overflow-y-auto lg:max-w-[calc(100%-20rem)] rounded-lg shadow-lg`}
      >
        <div className="px-10 py-5">
          <Intro />
          <div className={`${theme.secondary_bg()} h-[0.01rem] w-full mt-10`} />
          <div className="flex justify-between flex-wrap w-full mt-10">
            <LSLayout />
            <RSLayout />
          </div>
        </div>
      </div>
      <div
        className={`fixed bottom-5 right-5 xs:w-10 lg:w-12 xs:h-10 lg:h-12 flex justify-center items-center rounded-full ${theme.secondary_bg()} ${theme.secondary_fg()} cursor-pointer`}
        title={"Logout"}
        onClick={() => {
          (async () => {
            const { error } = await supabase.auth.signOut();
            if (!error) {
              navigate("/login");
            }
          })();
        }}
      >
        <BiLogOutCircle size={22} />
      </div>
      <div
        className={`xs:flex lg:hidden fixed bottom-20 right-5 xs:w-10 lg:w-12 xs:h-10 lg:h-12 justify-center items-center rounded-full ${theme.secondary_bg()} ${theme.secondary_fg()} cursor-pointer`}
        title={"Menu"}
        onClick={() => {
          setShow(!show);
        }}
      >
        <RxHamburgerMenu size={22} />
      </div>
      <div
        className={`${
          show ? "left-0" : "left-[-100%]"
        } fixed top-0 transition-all duration-200 w-full h-full bg-dark-bg p-5 overflow-y-auto`}
      >
        <AiOutlineClose
          className="absolute top-5 right-5 text-light-bg"
          onClick={() => {
            setShow(!show);
          }}
          size={20}
        />
        <div className={`text-md font-bold text-light-bg mb-5`}>
          Howdy {user},
        </div>
        {use && <Instruction />}
        <HowToUse use={use} setUse={setUse} />
        <DownloadTemplateJSON />
        <ImportResumeJSON />
        <ThemeChanger />
        <PreviewResume theme={getTheme} />
        <DownloadPDF />
        <DownloadResumeJSON />
      </div>
    </div>
  ) : (
    <div className="w-screen h-screen flex justify-center items-center">
      <BiLoaderAlt className="animate-spin" size={30} />
    </div>
  );
}

export default App;
